var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h20l8 8v-8h4a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm0 4h32v24H8zm28 4H12v4h24zM12 25h14v4H12zm24-6H12v4h24z"
  })));
};
export default SvgChat;